import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field } from 'formik';

import { FormControl, FormHelperText, Grid, InputLabel, Select, TextField } from '@material-ui/core';
import { clearSelectedLinesRequest, setSelectedLinesRequest } from 'app/store/slices/line';
import { FormServiceContext } from 'app/utils/contexts';

export const StripLineConectionFields = (props) => {
    const dispatch = useDispatch();
    const { errorsList } = useContext(FormServiceContext);

    const { lines = [], disabled = false, errors, touched } = props;
    // const [linhaSelecionada, setLinhaSelecionada] = useState(null);

    const { selectedLineId, selectedLinesRequest } = useSelector((state) => state.line);

    const validateRequired = (value) => {
        let error;
        if (!value || value === '') {
            error = 'Campo obrigatório';
        }
        return error;
    };

    const handleChangeLinhaSolicitacao = (selectedCdLinha) => {
        let cdLinhaSel = parseInt(selectedCdLinha);
        if (cdLinhaSel === -1) {
            dispatch(clearSelectedLinesRequest());
        } else {
            const linha = lines.find((linha) => linha.cdLinha === cdLinhaSel);
            dispatch(setSelectedLinesRequest([linha]));
        }
    };

    // useEffect(() => {
    //   console.log('FX 1');
    //   if (selectedLinesRequest && selectedLinesRequest.length > 0) {
    //     console.log('linesRequest && linesRequest.length > 0');
    //   }
    //   //eslint-disable-next-line
    // }, []);

    // useEffect(() => {
    //   console.log('EFX CLEAR bY SELECTED LINE ID');
    //   if (!!selectedLinesRequest.length) {
    //     dispatch(clearSelectedLinesRequest());
    //   }
    //   //eslint-disable-next-line
    // }, [selectedLineId]);

    return (
        <>
            <Grid item xs={12} sm={8}>
                <FormControl variant="filled" margin="dense" fullWidth disabled={disabled}>
                    <InputLabel htmlFor="flLinha" shrink={true}>
                        Linha 2*
                    </InputLabel>
                    <Field
                        name="linhaSolicitacao"
                        id="linha"
                        onChange={(e) => handleChangeLinhaSolicitacao(e.target.value)}
                        native
                        value={!!selectedLinesRequest.length ? selectedLinesRequest[0].cdLinha : '-1'}
                        as={Select}
                        error={!!errorsList.linesRequest}>
                        <option value="-1">Selecione...</option>
                        {lines ? (
                            lines
                                .filter((line) => line.cdLinha !== selectedLineId)
                                .map((line, idx) => (
                                    <option key={`${idx}-${line.cdLinha}`} value={line.cdLinha}>
                                        {line.deDescricao}
                                    </option>
                                ))
                        ) : (
                            <option>Nenhuma linha registrada</option>
                        )}
                    </Field>
                    {!!errorsList.linesRequest && (
                        <FormHelperText error id="component-helper-text">
                            Campo obrigatório
                        </FormHelperText>
                    )}
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={8}>
                <Field
                    as={TextField}
                    name="conexao"
                    label="Conexão*"
                    margin="dense"
                    variant="filled"
                    disabled={disabled}
                    validate={validateRequired}
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                    }}
                    error={Boolean(errors.conexao) && touched.conexao}
                    helperText={Boolean(errors.conexao) && touched.conexao ? errors.conexao : ''}
                    inputProps={{
                        maxLength: 100,
                    }}
                />
            </Grid>
        </>
    );
};
